<template>
  <div
    :class="[
      $style.hint,
      visible && $style.hintVisible
    ]"
    v-click-outside="closeTooltip"
  >
    <div :class="$style.hintContent">
      <div
        :data-testid="getTestId('hint-icon')"
        @mouseenter="toggleTooltip"
        @mouseleave="toggleTooltip"
        v-touch.prevent="toggleTooltip"
        ref="toggle"
        :style="{height: toogleSize}"
      >
        <slot>
          <b-svg
            :class="$style.hintIcon"
            :name="iconName"
            :url="iconUrl"
            :source="iconSource"
            :height="toogleSize"
          />
        </slot>
      </div>

      <b-tooltip
        :data-testid="getTestId('hint')"
        :position="getPosition()"
        ref="tooltip"
        :visible="visible"
        :description="description"
        :title="title"
        :no-padding-bottom="noPaddingBottom"
        :tooltip-width="tooltipWidth"
      >
        <template #content v-if="$slots.content">
          <slot name="content"></slot>
        </template>
      </b-tooltip>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ClickOutside from '@/booksy-vue-components/directives/click-outside'

export default defineComponent({

  emits: [
    'icon-click',
  ],
  name: 'b-hint',

  data () {
    return {
      visible: false,
    }
  },

  directives: {
    ClickOutside,
  },

  props: {
    testId: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: 'help',
    },
    iconUrl: String,
    iconSource: String,
    position: {
      type: String,
      default: 'right-center',
    },
    tooltipWidth: {
      type: String,
      default: '300px',
    },
    toogleSize: {
      type: String,
      default: '24px',
    },
    title: String,
    description: String,
    noPaddingBottom: Boolean,
    active: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    getTestId (prefix) {
      return `${prefix}${this.testId ? `-${this.testId}` : ''}`
    },

    closeTooltip () {
      if (this.visible) this.visible = false
    },

    toggleTooltip () {
      if (this.active) {
        if (!this.visible) {
          this.$emit('icon-click')
        }

        this.visible = !this.visible
      }
    },

    getPosition () {
      let position = this.position.split('-')

      if (this.$refs.tooltip && this.$refs.toggle) {
        const tooltipEl = (this.$refs.tooltip as { $el: HTMLElement }).$el
        const toggleEl = this.$refs.toggle as HTMLElement
        const tooltipWidth = tooltipEl.offsetWidth + toggleEl.offsetWidth + 41 // 17px offset from before and spacing plus 1.5rem buffer
        const leftPosition = toggleEl.getBoundingClientRect().left

        if (position[0] === 'right' && window.innerWidth - leftPosition < tooltipWidth) {
          position[0] = 'left'
        } else if (position[0] === 'left' && leftPosition < tooltipWidth) {
          position[0] = 'right'
        }
      }

      return position.join('-')
    },
  },
})

</script>

<style lang="scss" module>
@layer legacy-views {

.hint {
  align-items: center;
  justify-content: center;
  display: flex;

  &Icon {
    color: var(--color-gray-11);
    cursor: pointer;
    display: block;
  }
  &Content {
    position: relative;
  }
  &Visible {
    z-index: 200;
  }
}

}</style>
